import { adminHttpClient } from '../commons/adminHttpClient'

export type RecurringExpenseHistoryResponse = {
  recurringExpenseId: string
  reviewedBy: string
  reviewedOn: string
  messageToEmployee: string
  internalNotes: string
}

const getRecurringExpenseReviewHistory = (id: string): Promise<RecurringExpenseHistoryResponse[]> => {
  return adminHttpClient.get(`/Expenses/RecurringExpenseReviewHistoryDetails/${id}`)
}

export default getRecurringExpenseReviewHistory
